import VideoListItem from '../trade_hub/video_list_item';

const VideoList = ({ videoList }) =>
  videoList.map(video => (
    <div className="video-list__wrapper" key={video.Link}>
      <VideoListItem item={video} />
    </div>
  ));

export default VideoList;
